import { useTranslation } from 'react-i18next';
import { Dialog, DialogDescription, DialogHeader, DialogTitle } from 'components/dialog/dialog';
import {
  CancelDiscardButton,
  ConfirmDiscardButton,
  DiscardDialogContent,
  DiscardDialogFooter,
} from './DiscardConsultationDialog.styles';

interface DiscardConsultationDialogProps {
  isDiscarding: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DiscardConsultationDialog = ({
  isDiscarding,
  onConfirm,
  onClose,
}: DiscardConsultationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={(open) => !open && !isDiscarding && onClose()}>
      <DiscardDialogContent data-ph-no-autocapture>
        <DialogHeader>
          <DialogTitle>{t('recording.pausedConsultation.discardTitle')}</DialogTitle>
          <DialogDescription>
            {t('recording.pausedConsultation.discardDescription')}
          </DialogDescription>
        </DialogHeader>
        <DiscardDialogFooter>
          <CancelDiscardButton onClick={onClose} disabled={isDiscarding}>
            {t('cancel')}
          </CancelDiscardButton>
          <ConfirmDiscardButton onClick={onConfirm} disabled={isDiscarding}>
            {t('recording.pausedConsultation.discardConfirm')}
          </ConfirmDiscardButton>
        </DiscardDialogFooter>
      </DiscardDialogContent>
    </Dialog>
  );
};
